(function (Drupal, once) {
  Drupal.behaviors.topicCardTitleAlign = {
    attach: function (context) {
      once(
        'topic-card-title-align',
        '.paragraph-topic-card__row--aligned',
        context
      ).forEach(function (row) {
        var columns = row.querySelectorAll('.paragraph-topic-card__column');

        function equalize() {
          var titles = row.querySelectorAll('.global-card__title');
          var groups = {};

          // Reset first so measurements reflect each title's natural height,
          // not a min-height set by a previous run (e.g. before a resize).
          titles.forEach(function (title) {
            title.style.minHeight = '';
          });

          columns.forEach(function (column) {
            var title = column.querySelector('.global-card__title');
            if (!title) {
              return;
            }
            
            var top = Math.round(column.getBoundingClientRect().top);
            (groups[top] = groups[top] || []).push(title);
          });

          Object.keys(groups).forEach(function (top) {
            var group = groups[top];
            if (group.length < 2) {
              return;
            }
            var max = Math.max.apply(
              Math,
              group.map(function (title) {
                return title.offsetHeight;
              })
            );
            group.forEach(function (title) {
              title.style.minHeight = max + 'px';
            });
          });
        }

        equalize();

        // Font metrics aren't final until webfonts load, which can change
        // measured title heights after the first equalize() pass.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(equalize);
        }

        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(equalize, 150);
        });
      });
    },
  };
})(Drupal, once);
